/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ duration: NonNullable<unknown> }} Confirm_AdjustInputs */

const en_confirm_adjust = /** @type {(inputs: Confirm_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Was it ${i?.duration}? Adjust if needed:`)
};

const he_confirm_adjust = /** @type {(inputs: Confirm_AdjustInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`האם זה היה ${i?.duration}? התאם במידת הצורך:`)
};

/**
* | output |
* | --- |
* | "Was it {duration}? Adjust if needed:" |
*
* @param {Confirm_AdjustInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const confirm_adjust = /** @type {((inputs: Confirm_AdjustInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Confirm_AdjustInputs, { locale?: "en" | "he" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_confirm_adjust(inputs)
	return he_confirm_adjust(inputs)
});